module.exports = __webpack_public_path__ + "static/media/nursingliquid2.11936d1c.jpg";